import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, articles } from '@/mocks/articles';

export default function Home() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 4);
  const recentArticles = articles.slice(0, 6);

  const jsonLdWebPage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '奶水动画 | 母乳哺育互动动画科普平台',
    description: '专为新手妈妈打造的母乳哺育可视化科普平台，通过奶水动画演示了解母乳分泌原理、哺乳姿势、追奶技巧与断奶过渡。',
    url: 'https://naishuidonghua.cn/',
    inLanguage: 'zh-Hans',
    isPartOf: {
      '@type': 'WebSite',
      name: '奶水动画',
      url: 'https://naishuidonghua.cn/',
    },
  };

  const categoryIcons: Record<string, string> = {
    'milk-secretion': 'ri-drop-fill',
    'feeding-positions': 'ri-heart-pulse-fill',
    'milk-boosting': 'ri-arrow-up-circle-fill',
    'weaning': 'ri-emotion-happy-fill',
  };

  const categoryColors: Record<string, string> = {
    'milk-secretion': 'bg-accent-500',
    'feeding-positions': 'bg-primary-500',
    'milk-boosting': 'bg-secondary-500',
    'weaning': 'bg-accent-500',
  };

  const categoryBgColors: Record<string, string> = {
    'milk-secretion': 'bg-accent-100',
    'feeding-positions': 'bg-primary-100',
    'milk-boosting': 'bg-secondary-100',
    'weaning': 'bg-accent-100',
  };

  const categoryTextColors: Record<string, string> = {
    'milk-secretion': 'text-accent-700',
    'feeding-positions': 'text-primary-700',
    'milk-boosting': 'text-secondary-700',
    'weaning': 'text-accent-700',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLdWebPage)}</script>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20soft%20abstract%20flowing%20liquid%20art%2C%20gentle%20cream%20and%20soft%20rose%20gradient%2C%20organic%20fluid%20shapes%20like%20milk%20droplets%2C%20nurturing%20motherhood%20theme%2C%20minimalist%20abstract%20background%2C%20peaceful%20soothing%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20clean%20elegant%20composition&width=1800&height=1000&seq=hero-milk-animation-01&orientation=landscape"
            alt="奶水动画母乳哺育科普平台"
            className="absolute inset-0 w-full h-full object-cover"
            title="奶水动画 - 母乳哺育互动动画科普平台"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
          <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-4 leading-tight">
              奶水动画 · 母乳哺育科普平台
            </h1>
            <p className="text-base md:text-lg text-background-50/85 mb-8 max-w-xl mx-auto leading-relaxed">
              通过生动直观的<strong>奶水动画演示</strong>，帮助每一位新手妈妈了解母乳分泌原理、掌握哺乳姿势、学会追奶技巧与断奶过渡
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/milk-secretion"
                className="bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-1.5"></i>开始学习
              </Link>
              <Link
                to="/about"
                className="bg-background-50/20 text-background-50 border border-background-50/30 px-6 py-3 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                四大核心科普主题
              </h2>
              <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
                从泌乳原理到断奶过渡，全方位动画科普，助你轻松掌握哺乳知识
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${categoryBgColors[cat.slug]} mb-4 group-hover:scale-110 transition-transform`}>
                    <i className={`${categoryIcons[cat.slug]} ${categoryTextColors[cat.slug]} text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                    {cat.description}
                  </p>
                  <span className="text-xs text-foreground-400">
                    {cat.articleCount} 篇文章
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles Section */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                精选科普文章
              </h2>
              <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
                精选最受欢迎的母乳哺育科普内容，帮你快速找到需要的信息
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
              {featuredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className="flex flex-col sm:flex-row">
                    <div className="sm:w-48 h-40 sm:h-auto flex-shrink-0 overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        title={article.title}
                      />
                    </div>
                    <div className="p-4 md:p-5 flex flex-col justify-between flex-1">
                      <div>
                        <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 mb-2 whitespace-nowrap">
                          {article.categoryName}
                        </span>
                        <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                          {article.title}
                        </h3>
                        <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                          {article.excerpt}
                        </p>
                      </div>
                      <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line"></i>{article.readTime} 分钟阅读
                        </span>
                        <span>{article.date}</span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* All Articles Quick Grid */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
                最新科普内容
              </h2>
              <Link
                to="/category/milk-secretion"
                className="text-sm text-primary-600 hover:text-primary-700 flex items-center gap-1 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {recentArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
                >
                  <div className="h-44 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={article.title}
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 mb-2 whitespace-nowrap">
                      {article.categoryName}
                    </span>
                    <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>{article.readTime} 分钟
                      </span>
                      <span>{article.date}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20abstract%20warm%20gradient%20with%20flowing%20organic%20shapes%2C%20gentle%20cream%20and%20rose%20tones%2C%20nurturing%20peaceful%20atmosphere%2C%20minimalist%20abstract%20background%2C%20no%20text%2C%20motherhood%20warmth%20theme&width=1800&height=600&seq=cta-milk-animation-02&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-primary-500/70 to-accent-500/60"></div>
          <div className="relative z-10 text-center px-4 max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
              准备好开始科学哺乳之旅了吗？
            </h2>
            <p className="text-background-50/85 text-sm md:text-base mb-8 leading-relaxed">
              加入奶水动画科普平台，用最直观的动画演示，轻松掌握母乳哺育的每一个环节
            </p>
            <Link
              to="/category/milk-secretion"
              className="inline-flex items-center gap-2 bg-background-50 text-primary-600 px-6 py-3 rounded-full text-sm font-medium hover:bg-background-50/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-drop-fill"></i>立即开始探索
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}